export default __webpack_public_path__ + "static/media/stimulation.31d5390e.webp";